import React, { useState } from "react"
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from "@impelsys/material-ui-pickers"
import { useTheme } from "@material-ui/styles"
import { useMediaQuery } from "@material-ui/core"
import MomentUtils from "@date-io/moment"
import moment from "moment"
import { t } from "@lingui/macro"
import { useDateUtils } from "@utils/useDateUtils"

const DateTimePicker = ({
  label,
  placeholder = t`Enter date and time`,
  value,
  onChange,
  clearLabel = t`Today`,
  clearable = false,
  smartStripTime,
  showTodayButton = false,
  okLabel = "",
  autoOk = true,
  disabled = false,
  ...rest
}) => {
  const theme = useTheme()
  const xs = useMediaQuery(theme.breakpoints.down("xs"))
  const { hasTime } = useDateUtils()
  const [open, setOpen] = useState(false)

  const handleChange = (date) => {
    if (clearable && !date) {
      onChange(null)
      return
    }
    onChange(smartStripTime && !hasTime(value) && date ? date.startOf("day") : date || moment().startOf("day"))
  }
  const handleClick = () => {
    if (disabled) return
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <KeyboardDateTimePicker
        label={label}
        placeholder={placeholder}
        value={value}
        open={open}
        inputVariant="outlined"
        minutesStep={5}
        InputAdornmentProps={{ position: "end", style: { marginRight: -16 } }}
        format={xs ? "DD/MMM/Y hh:mm A z" : "Do MMMM Y hh:mm A z"}
        onChange={handleChange}
        onClick={handleClick}
        onClose={handleClose}
        clearable={clearable}
        clearLabel={clearLabel}
        showTodayButton={showTodayButton}
        fullWidth
        okLabel={okLabel}
        autoOk={autoOk}
        disabled={disabled}
        {...rest}
      />
    </MuiPickersUtilsProvider>
  )
}

export { DateTimePicker }
